import { SfConvertPage } from "app/pages/sales-intelligence/pages/sfconvert/SfConvertPage";
import { SwTrack } from "app/services/SwTrack";
import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

export const sfConvertConfig: RouterStateConfig = {
    "pro-iframe-sf": {
        url: "/sf/convert/:isWWW/:key",
        pageId: {
            section: "sfiframe",
            subSection: "convert",
        },
        icon: "sw-icon-home",
        clearSearch: true,
        trackingId: {
            section: "sfiframe",
            subSection: "convert",
        },
        data: {
            getCustomUrlType(toState: any) {
                // website | apps | keywords | industryAnalysis
                return this.getTrackId(toState).section;
            },
            getTrackId(toState: any) {
                return toState.trackingId || toState.pageId;
            },
            pageViewTracking({ toParams, toState }: any) {
                // event param was added in order to differentiate between navChangeSuccess to navUpdate
                SwTrack.trackPageView(toState, toParams);
            },
        },
        params: {
            isWWW: "*",
        },
        configId: "WebAnalysis",
        pageTitle: "swhome.page.title",
        skipDurationCheck: true,
        skipCountryCheck: true,
        component: SfConvertPage,
        hideFromRecents: true,
    },
};
